/* ============================================================
   LiberNovo floating video widget
   Paired with sections/lnx-video-widget.liquid + assets/section-lnx-video-widget.css

   Mini-player: muted + looping (the only autoplay browsers allow), with a
   progress ring driven off timeupdate. Expanding is a user gesture, which is
   exactly what unblocks audio — so the fullscreen player starts unmuted from
   the same timestamp, with a muted retry if the browser still says no.
   ============================================================ */

(function () {
  'use strict';

  var RING = 2 * Math.PI * 48; // r=48 in the SVG viewBox
  var DISMISS_KEY = 'lnxvw:dismissed';
  var CLIP_KEY = 'lnxvw:clip';

  function store(kind) {
    try {
      var s = kind === 'session' ? window.sessionStorage : window.localStorage;
      s.getItem(DISMISS_KEY);
      return s;
    } catch (e) {
      return null; // private mode / blocked storage: widget still works, just doesn't remember
    }
  }

  // ---- analytics ----
  // Goes to Statsig (custom events) and to dataLayer for GTM. Events queue until
  // the Statsig client is ready: the widget mounts on an idle callback and the
  // impression is the denominator of the whole funnel, so losing it skews the rest.
  var pending = [];

  function statsigClient() {
    try {
      var S = window.__STATSIG__;
      var c = S && typeof S.instance === 'function' ? S.instance() : null;
      return c && typeof c.logEvent === 'function' ? c : null;
    } catch (e) {
      return null;
    }
  }

  function flush() {
    var c = statsigClient();
    if (!c) return false;
    while (pending.length) {
      var e = pending.shift();
      try { c.logEvent(e); } catch (err) { /* never let analytics break the widget */ }
    }
    return true;
  }

  function track(event, clip, extra) {
    var meta = {
      clip: (clip && (clip.sublabel || clip.label)) || '',
      product: (clip && clip.title) || '',
      url: (clip && clip.url) || ''
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) meta[k] = String(extra[k]);
      }
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      lnx_video_clip: meta.clip,
      lnx_video_product: meta.product,
      lnx_video_url: meta.url
    });

    // Statsig v3 wants metadata values as strings
    pending.push({ eventName: event, value: meta.clip, metadata: meta });
    if (!flush()) {
      window.setTimeout(flush, 2000);
      window.setTimeout(flush, 8000);
    }
  }

  function init(root) {
    if (!root || root.dataset.lnxvwReady === '1') return;

    var dataEl = root.querySelector('[data-lnxvw-clips]');
    var clips;
    try {
      clips = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    clips = (clips || []).filter(function (c) { return c && c.video; });
    if (!clips.length) return;

    root.dataset.lnxvwReady = '1';

    var reappear = root.dataset.reappear || 'session';
    var local = store('local');
    var session = store('session');

    // ---- has the visitor already dismissed it? ----
    if (reappear === 'session') {
      if (session && session.getItem(DISMISS_KEY)) return;
    } else if (local) {
      var until = local.getItem(DISMISS_KEY);
      if (until === 'never') return;
      if (until && Date.now() < parseInt(until, 10)) return;
    }

    // ---- pick a clip ----
    // A clip for the product on screen wins outright. Otherwise take the one
    // pinned for this session, so browsing the site doesn't reshuffle the video.
    var index = 0;
    var matchIdx = clips.map(function (c) { return c.id; }).indexOf(root.dataset.match || '');
    var pageMatch = matchIdx >= 0;

    if (pageMatch) {
      index = matchIdx;
    } else {
      var pinned = session && session.getItem(CLIP_KEY);
      var pinnedIdx = clips.map(function (c) { return c.id; }).indexOf(pinned);
      if (pinnedIdx >= 0) {
        index = pinnedIdx;
      } else {
        index = Math.floor(Math.random() * clips.length);
        if (session) session.setItem(CLIP_KEY, clips[index].id);
      }
    }

    var $ = function (sel) { return root.querySelector(sel); };

    var dock = $('[data-lnxvw-open]');
    var mini = $('[data-lnxvw-mini]');
    var ring = $('[data-lnxvw-ring]');
    var labelEl = $('[data-lnxvw-label]');
    var subEl = $('[data-lnxvw-sub]');
    var pillSound = $('[data-lnxvw-sound]');
    var pillPlay = $('[data-lnxvw-play]');
    var modal = $('[data-lnxvw-modal]');
    var full = $('[data-lnxvw-full]');
    var modalSound = $('[data-lnxvw-modal-sound]');
    var prevBtn = $('[data-lnxvw-prev]');
    var nextBtn = $('[data-lnxvw-next]');
    var cta = $('[data-lnxvw-cta]');

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = window.matchMedia('(hover: none)').matches;
    if (coarse) root.classList.add('is-controls');

    // measure rather than trust 2*PI*r: the rendered path length differs slightly,
    // which otherwise leaves the ring a hair short of closing
    var circumference = (ring.getTotalLength && ring.getTotalLength()) || RING;
    ring.style.strokeDasharray = circumference;
    ring.style.strokeDashoffset = circumference;

    // ---------- helpers ----------

    function icons(btn, muted) {
      if (!btn) return;
      var m = btn.querySelector('[data-icon-muted]');
      var l = btn.querySelector('[data-icon-loud]');
      if (m) m.hidden = !muted;
      if (l) l.hidden = muted;
    }

    function playIcons(paused) {
      if (!pillPlay) return;
      var p = pillPlay.querySelector('[data-icon-play]');
      var s = pillPlay.querySelector('[data-icon-pause]');
      if (p) p.hidden = !paused;
      if (s) s.hidden = paused;
    }

    function paintBubble(clip) {
      labelEl.textContent = clip.label || '';
      subEl.textContent = clip.sublabel || '';
      if (clip.poster) mini.setAttribute('poster', clip.poster);
      if (mini.dataset.src !== clip.video) {
        mini.dataset.src = clip.video;
        mini.src = clip.video;
      }
    }

    function paintOffer(clip) {
      var img = $('[data-lnxvw-offer-img]');
      var disc = $('[data-lnxvw-disc]');
      var comp = $('[data-lnxvw-compare]');
      if (clip.thumb) { img.src = clip.thumb; img.alt = clip.title || ''; img.hidden = false; }
      else { img.hidden = true; }
      // no product picked and no link yet: nothing honest to offer, so hide the card
      cta.hidden = clip.hasOffer === false;

      // On the clip's own product page "view product" would go nowhere, so the
      // button drops the visitor at the buy box instead. The arrow points down
      // because it scrolls — it does not add anything to the cart by itself.
      var label = $('[data-lnxvw-cta-label]');
      var icon = $('[data-lnxvw-cta-icon]');
      label.firstChild.textContent = (clip.isCurrent ? label.dataset.buy : label.dataset.view) + ' ';
      icon.textContent = clip.isCurrent ? '\u2193' : '\u203a';
      $('[data-lnxvw-offer-title]').textContent = clip.title || '';
      var from = $('[data-lnxvw-from]');
      from.textContent = clip.pricePrefix || '';
      from.hidden = !clip.pricePrefix;
      $('[data-lnxvw-price]').textContent = clip.price || '';
      if (clip.discount > 0) { disc.textContent = '−' + clip.discount + '%'; disc.hidden = false; }
      else { disc.hidden = true; }
      if (clip.compare) { comp.textContent = clip.compare; comp.hidden = false; }
      else { comp.hidden = true; }
      cta.href = clip.url || '#';
    }

    var rafId = null;

    function paintRing() {
      var d = mini.duration;
      if (!d || !isFinite(d)) return;
      ring.style.strokeDashoffset = circumference * (1 - mini.currentTime / d);
    }

    // timeupdate only fires ~4x/sec, which on a 10s clip advances the arc in 2.5%
    // jumps. Animate off rAF instead, and only while it could actually move.
    function spin() {
      paintRing();
      rafId = mini.paused ? null : requestAnimationFrame(spin);
    }

    function startRing() {
      if (rafId === null && !mini.paused && !document.hidden) rafId = requestAnimationFrame(spin);
    }

    function stopRing() {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    }

    // ---------- mount ----------

    function mount() {
      paintBubble(clips[index]);
      paintOffer(clips[index]);
      root.hidden = false;
      // next frame, so the entry transition actually runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-in'); });
      });
      if (!reduced) {
        mini.play().then(function () { playIcons(false); }).catch(function () { playIcons(true); });
      } else {
        playIcons(true);
      }
      track('lnx_video_impression', clips[index]);
    }

    var delay = parseInt(root.dataset.delay, 10) || 0;
    var start = function () { window.setTimeout(mount, delay); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: delay + 2000 });
    else window.addEventListener('load', start);

    // ---- keep clear of a bottom sticky bar (product pages only) ----
    // Mirrors what layout/theme.liquid already does for the WhatsApp button:
    // sniff the bottom-centre of the viewport for a real, opaque, full-width bar.
    if (root.dataset.lift === 'true') {
      var lifted = 0;
      var ticking = false;

      var measure = function () {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          if (lifted) { lifted = 0; root.style.setProperty('--lnxvw-lift', '0px'); }
          return;
        }
        var els = document.elementsFromPoint(Math.round(window.innerWidth / 2), window.innerHeight - 4) || [];
        var barTop = null;
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          if (el === root || root.contains(el)) continue;
          var cs = window.getComputedStyle(el);
          if (cs.position !== 'fixed') continue;
          var r = el.getBoundingClientRect();
          if (r.width < window.innerWidth * 0.6) continue;
          if (r.height <= 24 || r.height >= window.innerHeight * 0.5) continue;
          if (r.bottom < window.innerHeight - 4) continue;
          barTop = r.top;
          break;
        }
        var next = barTop === null ? 0 : Math.max(0, Math.round(window.innerHeight - barTop + 10));
        if (next !== lifted) {
          lifted = next;
          root.style.setProperty('--lnxvw-lift', next + 'px');
        }
      };

      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { measure(); ticking = false; });
      };

      measure();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    mini.addEventListener('play', startRing);
    mini.addEventListener('pause', stopRing);
    mini.addEventListener('loadedmetadata', paintRing);
    mini.addEventListener('timeupdate', paintRing); // keeps the arc honest if rAF is throttled

    // don't burn CPU/data behind a hidden tab
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { mini.pause(); stopRing(); }
      else if (!root.classList.contains('is-open') && !mini.dataset.userPaused && !reduced) {
        mini.play().catch(function () {});
      }
    });

    // ---------- bubble controls ----------

    pillPlay.addEventListener('click', function (e) {
      e.stopPropagation();
      if (mini.paused) {
        mini.dataset.userPaused = '';
        mini.play().then(function () { playIcons(false); }).catch(function () {});
      } else {
        mini.pause();
        mini.dataset.userPaused = '1';
        playIcons(true);
      }
    });

    pillSound.addEventListener('click', function (e) {
      e.stopPropagation();
      mini.muted = !mini.muted;
      icons(pillSound, mini.muted);
      if (!mini.muted) mini.play().catch(function () { mini.muted = true; icons(pillSound, true); });
    });

    $('[data-lnxvw-close]').addEventListener('click', function (e) {
      e.stopPropagation();
      mini.pause();
      root.classList.remove('is-in');
      window.setTimeout(function () { root.hidden = true; }, 350);
      if (reappear === 'session') {
        if (session) session.setItem(DISMISS_KEY, '1');
      } else if (local) {
        local.setItem(DISMISS_KEY, reappear === 'never' ? 'never' : String(Date.now() + parseInt(reappear, 10) * 86400000));
      }
      track('lnx_video_dismiss', clips[index]);
    });

    // ---------- fullscreen player ----------

    var lastFocus = null;

    function loadFull(clip, startAt) {
      // the bubble streams the light rendition; fullscreen is opt-in, so it can
      // afford the better one
      full.src = clip.videoHd || clip.video;
      if (clip.poster) full.poster = clip.poster;
      full.muted = false;
      var seek = function () {
        full.removeEventListener('loadedmetadata', seek);
        if (startAt > 0 && isFinite(full.duration)) {
          try { full.currentTime = Math.min(startAt, full.duration - 0.1); } catch (e) { /* ignore */ }
        }
      };
      full.addEventListener('loadedmetadata', seek);
      full.play().then(function () {
        icons(modalSound, false);
      }).catch(function () {
        // browser refused audio: fall back to muted so the clip still plays
        full.muted = true;
        icons(modalSound, true);
        full.play().catch(function () {});
      });
    }

    function open() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('lnxvw-open');
      prevBtn.hidden = nextBtn.hidden = clips.length < 2;
      paintOffer(clips[index]);
      loadFull(clips[index], mini.currentTime);
      mini.pause();
      stopRing();
      modal.querySelector('[data-lnxvw-modal-close]').focus();
      track('lnx_video_expand', clips[index]);
    }

    function close() {
      var at = full.currentTime;
      var total = full.duration;
      track('lnx_video_close', clips[index], {
        seconds: Math.round(at),
        percent: total && isFinite(total) ? Math.min(100, Math.round((at / total) * 100)) : 0,
        sound: full.muted ? 'muted' : 'on'
      });
      full.pause();
      full.removeAttribute('src');
      full.load();
      modal.hidden = true;
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.classList.remove('lnxvw-open');
      paintBubble(clips[index]);
      if (at > 0 && isFinite(mini.duration)) {
        try { mini.currentTime = Math.min(at, mini.duration - 0.1); } catch (e) { /* ignore */ }
      }
      if (!reduced && !mini.dataset.userPaused) mini.play().catch(function () {});
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function step(dir) {
      index = (index + dir + clips.length) % clips.length;
      if (session && !pageMatch) session.setItem(CLIP_KEY, clips[index].id);
      mini.dataset.src = '';
      paintOffer(clips[index]);
      loadFull(clips[index], 0);
    }

    dock.addEventListener('click', open);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });

    Array.prototype.forEach.call(modal.querySelectorAll('[data-lnxvw-modal-close]'), function (el) {
      el.addEventListener('click', close);
    });

    modalSound.addEventListener('click', function () {
      full.muted = !full.muted;
      icons(modalSound, full.muted);
      if (!full.muted) full.play().catch(function () {});
    });

    // Aim at the price/add-to-cart block, not the <form>: on the LiberNovo PDP the
    // form wraps the whole buy experience (2000px+) and centring it lands nowhere.
    var BUY_TARGETS = ['[name="add"]', '.lnx-price-row', '.product-form__buttons', '.price'];

    function buyBox() {
      var scope = document.getElementById('MainContent') || document;
      for (var s = 0; s < BUY_TARGETS.length; s++) {
        var els = scope.querySelectorAll(BUY_TARGETS[s]);
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          if (r.width > 0 && r.height > 0) return els[i];
        }
      }
      return scope.querySelector('form[action*="/cart/add"]');
    }

    cta.addEventListener('click', function (e) {
      track('lnx_video_cta', clips[index]);
      if (!clips[index].isCurrent) return;
      var target = buyBox();
      if (!target) return; // no form found: let the href take over
      e.preventDefault();
      close();

      // A smooth scroll silently does nothing where animations don't run (a
      // background tab, reduced-motion, some in-app browsers), which reads as a
      // dead button. Jump instead if nothing has moved shortly after.
      var from = window.scrollY;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(function () {
        if (Math.abs(window.scrollY - from) < 2) {
          target.scrollIntoView({ behavior: 'auto', block: 'center' });
        }
      }, 400);
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && clips.length > 1) step(-1);
      else if (e.key === 'ArrowRight' && clips.length > 1) step(1);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lnxvw]'), init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // theme editor: re-run when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-lnxvw]') : null;
    if (el) init(el);
  });
})();
